import { BenefitCategory } from '@flexyoo/api';
import { BenefitSupplierType } from '@flexyoo/api/models';
import { BenefitStatus, isLongTermBenefitCategory } from '@flexyoo/benefits/declarations';

export type IDeliverableBenefitTransaction = {
  status: BenefitStatus;
  supplierType: BenefitSupplierType;
  category: number;
};

export const canDeliverBenefitTransaction = (
  transaction: IDeliverableBenefitTransaction
): boolean => {
  const isEligibleSupplier =
    transaction.supplierType === BenefitSupplierType.None ||
    transaction.supplierType === BenefitSupplierType.BlueTrees;

  const category = transaction.category as BenefitCategory;
  // Upgrade car budget is a multi-year leasing benefit, but not part of the long-term categories
  const isLeasingCategory =
    isLongTermBenefitCategory(category) || category === BenefitCategory.UpgradeCarBudget;

  return transaction.status === 'hr-approved' && isEligibleSupplier && isLeasingCategory;
};
